export const SET_APP_DATA = 'app/SET_APP_DATA';
